module.exports = __webpack_public_path__ + "fonts/effect-fire-and-forget-ddfcec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-fire-and-forget.svg
// module id = 753
// module chunks = 0